import { Images, QuestionGroup, QuestionType, ScenarioStep, Steps } from '../state/interfaces'
import { emailAddress, lastName, thanks } from './common-steps'

export const thanksTicket: ScenarioStep = {
  ...thanks,
  question: 'thanks-ticket_question',
  tip: 'thanks-ticket_tip',
}

export const lastNameTicket: ScenarioStep = {
  ...lastName,
  next: Steps.EMAIL_ADDRESS_TICKET,
}

export const ticketInitialInfo: ScenarioStep = {
  id: Steps.TICKET_INITIAL_INFO,
  type: QuestionType.RADIO_DEFAULT,
  group: QuestionGroup.DEFAULT,
  question: 'ticket-initial-info_question',
  next: Steps.FIRST_NAME,
  answerPlaceholder: 'ticket-initial-info_answerPlaceholder',
  answers: [
    {
      id: 'cant-find-offer',
      text: 'cant-find-offer_option',
    },
    {
      id: 'price-wrong',
      text: 'price-wrong_option',
    },
    {
      id: 'other-problem',
      text: 'other-problem_option',
    },
  ],
  metadata: { grandImage: Images.TICKET_1 },
}

export const emailAddressTicket: ScenarioStep = {
  ...emailAddress,
  id: Steps.EMAIL_ADDRESS_TICKET,
  next: Steps.COMMENT_TICKET,
}

export const commmentTicket: ScenarioStep = {
  id: Steps.COMMENT_TICKET,
  group: QuestionGroup.DEFAULT,
  question: 'comment-ticket_question',
  tip: 'comment-ticket_tip',
  type: QuestionType.TEXTAREA,
  answerPlaceholder: 'comment-ticket_answerPlaceholder',
  next: Steps.THANKS,
  answers: [],
  metadata: { grandImage: Images.TICKET_3 },
}
